// Persisted in localStorage so the adult content acknowledgement carries
// across browser sessions (shown once per login rather than once per browser
// session). Cleared on logout so the next login must acknowledge again.
const ADULT_WARNING_STORAGE_KEY = 'adult_content_ack';

export const isAdultWarningAccepted = () => {
  try {
    return localStorage.getItem(ADULT_WARNING_STORAGE_KEY) === 'true';
  } catch (error) {
    return false;
  }
};

export const setAdultWarningAccepted = () => {
  try {
    localStorage.setItem(ADULT_WARNING_STORAGE_KEY, 'true');
  } catch (error) {
    // localStorage may be unavailable (private mode / blocked); fail silently.
  }
};

export const clearAdultWarningAccepted = () => {
  try {
    localStorage.removeItem(ADULT_WARNING_STORAGE_KEY);
  } catch (error) {
    // localStorage may be unavailable (private mode / blocked); fail silently.
  }
};
